import type { IApiKey } from 'modules/api_public/store/models/ApiKey'

export const sortingApiKeys = (apiKey: IApiKey, sortAttribute: string) => {
  switch (sortAttribute) {
    case 'name':
      return apiKey.name.toLowerCase()

    case 'created_at':
      return apiKey.created_at

    default:
      return apiKey.name
  }
}
